// extracted by mini-css-extract-plugin
export default {"slide-pdf":"UploadCard_slide-pdf__3X6im","slide-image":"UploadCard_slide-image__Ioz7N","title":"UploadCard_title__xR4nS","Image-styling":"UploadCard_Image-styling__g-wkC"};